/**
 * 这个工具主要的是处理Dva的方法
 */

export function onUpdateEffect(effect: any, { put }: any, model: any, actionType: any) {
  return function*(args: any) {
    function updateState(payload: any) {
      return { type: 'updateState', payload };
    }
    yield effect({ ...args, updateState });
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/dvaUtils.ts